import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonBaseComponent } from '../button-base.components';

@Component({
  selector: 'app-fab-button',
  templateUrl: './fab-button.component.html',
  styleUrls: ['./fab-button.component.scss'],
})
export class FabButtonComponent extends ButtonBaseComponent {
  @Input() icon = '';
  @Input() disabled: boolean;
  @Input() iconUrl = 'assets/image/plus.svg';
  @Input() isTransparent = false;
  @Input() buttonSize: 'primary-button' | 'secondary-button' | 'tertiary-button' = 'primary-button';

  @Output() buttonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
}
